module.exports = __webpack_public_path__ + "img/chatbox.cd6496fe.svg";